"use client";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import type { CentraOrder } from "@/lib/centra/selection/selectionFormatter";

import type { CentraAddress } from "../../Selection/formatters";
import useSelection from "../../Selection/useSelection";
import { useConfig } from "../../useConfig";
import useToken from "../../useToken";
import usePaymentStore from "./usePaymentStore";

export type PaymentResultType = {
  order: CentraOrder;
  errors: {
    paymentMethod: string;
  };
};
// function paramsToObject(entries: [string, string][]) {
//   const result: { [key: string]: string } = {}; // add type annotation to result object
//   for (const [key, value] of entries) {
//     // each 'entry' is a [key, value] tupple
//     result[key] = value;
//   }
//   return result;
// }
const useAdyenResult = () => {
  const { paymentResult, setPaymentResult } = usePaymentStore();

  const [error, setError] = useState<string>("");
  const { config } = useConfig();

  const apiUrl = config?.centra.url;
  const router = useRouter();

  const query = router.query;

  const { token: local_token } = useToken();
  const { address } = useSelection();
  async function sendResultToCentra() {
    if (typeof query?.redirectResult !== "undefined") {
      if (paymentResult) {
        if (paymentResult.order) {
          if (paymentResult?.order?.items?.length > 0) {
            // eventPurchase({
            //   transaction_id: paymentResult?.order.order,
            //   value: paymentResult?.order.totals.grandTotalPriceAsNumber,
            //   currency: paymentResult?.order.currency,
            //   coupon: paymentResult?.order.discounts.vouchers[0]?.voucher || "",
            //   tax: paymentResult?.order.totals.taxAsNumber || 0,
            //   shipping: paymentResult?.order.totals.shippingAsNumber || 0,

            //   items:
            //     paymentResult?.order?.items.map((item) => ({
            //       item_id: item.product.productSku,
            //       item_name: item.product.name,
            //       item_category: item?.product?.categoryName?.[0] || "",
            //       item_category2:
            //         item.product.categoryName?.[1] &&
            //         item.product.categoryName?.[1],
            //       item_variant: item.product.variantName,
            //       price: item.priceEachBeforeDiscountAsNumber || 0,
            //       quantity: item.quantity,
            //     })) || [],
            // });
            setPaymentResult(paymentResult);
          }
          return;
        }
        if (paymentResult.errors) {
          setError(paymentResult.errors.paymentMethod);
          return;
        }
      } else {
        const newQuery = { ...query, page: null };
        const paymentMethodFields = newQuery;

        if (query?.orderData) {
          const data = JSON.parse(
            decodeURIComponent(query?.orderData as string)
          ) as PaymentResultType;
          if (data) {
            if (data?.errors) {
              return setError(data?.errors?.paymentMethod || "not found");
            }

            if (data?.order && !paymentResult) {
              // const paymentdata = data.order;
              // eventPurchase({
              //   transaction_id: paymentdata.order,
              //   value: paymentdata.totals.grandTotalPriceAsNumber,
              //   currency: paymentdata.currency,
              //   coupon: paymentdata.discounts.vouchers[0] || "",
              //   tax: paymentdata.totals.taxAddedAsNumber || 0,
              //   shipping: paymentdata.totals.shippingPriceAsNumber || 0,

              //   items:
              //     paymentdata?.items.map((item) => ({
              //       item_id: item.product.productSku,
              //       item_name: item.product.name,
              //       item_category: item.product.categoryName[0] || "",
              //       item_category2:
              //         item.product.categoryName[1] &&
              //         item.product.categoryName[1],
              //       item_variant: item.product.variantName,
              //       price: item.priceEachBeforeDiscountAsNumber || 0,
              //       quantity: item.quantity,
              //     })) || [],
              // });
              return setPaymentResult(data);
            }
          }
        } else {
          try {
            const res = await fetch(
              `${apiUrl}/payment-result`,

              {
                method: "POST",
                body: JSON.stringify({
                  paymentMethodFields,
                }),
                headers: {
                  "Content-Type": "application/json",
                  "API-Token": local_token || "",
                },
              }
            );

            const data = (await res.json()) as PaymentResultType;

            if (data) {
              if (data?.errors) {
                return setError(data?.errors?.paymentMethod || "not found");
              }
              if (data?.order && !paymentResult) {
                // const paymentdata = data.order;
                // eventPurchase({
                //   transaction_id: paymentdata.order,
                //   value: paymentdata?.totals?.grandTotalPriceAsNumber || 0,
                //   currency: paymentdata.currency,
                //   coupon: paymentdata?.discounts?.vouchers?.[0] || "",
                //   tax: paymentdata?.totals?.taxAddedAsNumber || 0,
                //   shipping: paymentdata?.totals?.shippingPriceAsNumber || 0,

                //   items:
                //     paymentdata?.items?.map((item) => ({
                //       item_id: item?.product?.productSku,
                //       item_name: item?.product?.name,
                //       item_category: item?.product?.categoryName[0] || "",
                //       item_category2:
                //         item?.product?.categoryName[1] &&
                //         item?.product?.categoryName[1],
                //       item_variant: item?.product?.variantName,
                //       price: item.priceEachBeforeDiscountAsNumber || 0,
                //       quantity: item.quantity,
                //     })) || [],
                // });
                return setPaymentResult(data);
              }
            }
          } catch (e: any) {
            console.error(e);
            if (e?.response?.data?.errors?.selection) {
              setError(e.response.data.errors.selection);
              return;
            }
            if (e?.response && e?.response?.data?.errors) {
              // try {
              //   const res = await axios.get(`${apiUrl}/receipt`, {
              //     headers: {
              //       "Content-Type": "application/json",
              //       "API-Token": local_token || "",
              //     },
              //   });
              //   const data = await res.data;
              //   if (data) {
              //     if (data.errors) {
              //       setError(data.errors.paymentMethod);
              //     }
              //     if (data.order) {
              //       setPaymentData(data.order);
              //     }
              //   }
              // } catch (e: any) {
              return setError(
                e?.response?.data?.errors?.paymentMethod || "not found"
              );
              // }
            }
            return setError("not found");
          }
        }
      }
    } else if (query?.resultCode === "cancelled") {
      return setError("failed");
    }

    if (query.centraPaymentMethod) {
      const paymentMethodFields = query;
      try {
        const res = await fetch(
          `${apiUrl}/payment-result`,

          {
            method: "POST",
            body: JSON.stringify({
              paymentMethodFields,
            }),
            headers: {
              "Content-Type": "application/json",
              "API-Token": local_token || "",
            },
          }
        );

        const data = (await res.json()) as PaymentResultType;

        if (data) {
          if (data?.errors) {
            return setError(data?.errors?.paymentMethod || "not found");
          }
          if (data?.order && !paymentResult) {
            // const paymentdata = data.order;
            // eventPurchase({
            //   transaction_id: paymentdata.order,
            //   value: paymentdata?.totals?.grandTotalPriceAsNumber || 0,
            //   currency: paymentdata.currency,
            //   coupon: paymentdata?.discounts?.vouchers?.[0] || "",
            //   tax: paymentdata?.totals?.taxAddedAsNumber || 0,
            //   shipping: paymentdata?.totals?.shippingPriceAsNumber || 0,

            //   items:
            //     paymentdata?.items?.map((item) => ({
            //       item_id: item?.product?.productSku,
            //       item_name: item?.product?.name,
            //       item_category: item?.product?.categoryName[0] || "",
            //       item_category2:
            //         item?.product?.categoryName[1] &&
            //         item?.product?.categoryName[1],
            //       item_variant: item?.product?.variantName,
            //       price: item.priceEachBeforeDiscountAsNumber || 0,
            //       quantity: item.quantity,
            //     })) || [],
            // });
            return setPaymentResult(data);
          }
        }
      } catch (e: any) {
        if (e?.response?.data?.errors?.selection) {
          setError(e.response.data.errors.selection);
          return;
        }
        if (e?.response && e?.response?.data?.errors) {
          // try {
          //   const res = await axios.get(`${apiUrl}/receipt`, {
          //     headers: {
          //       "Content-Type": "application/json",
          //       "API-Token": local_token || "",
          //     },
          //   });
          //   const data = await res.data;
          //   if (data) {
          //     if (data.errors) {
          //       setError(data.errors.paymentMethod);
          //     }
          //     if (data.order) {
          //       setPaymentData(data.order);
          //     }
          //   }
          // } catch (e: any) {
          return setError(
            e?.response?.data?.errors?.paymentMethod || "not found"
          );
          // }
        }
        return setError("not found");
      }
    }

    return;
  }
  useEffect(() => {
    sendResultToCentra();
  }, [query, paymentResult, apiUrl, local_token]);

  return {
    paymentdata: paymentResult?.order,
    error: error || paymentResult?.errors?.paymentMethod,
    address: {
      ...(address as CentraAddress),
      termsAndConditions: true,
    },
  };
};

export default useAdyenResult;

export type AdyenResult = ReturnType<typeof useAdyenResult>;
